import { DtDateRange } from '@ow/ditto-core'
const { filterSpec } = DtDateRange

export { default as Filter } from './filter'
export { filterSpec }
